import React from 'react'
import styles from './styles.module.scss'

function About({ aboutText, name, titleCSS }) {
  return aboutText ? <p className={styles.about}>{aboutText}</p> : null
}

export default About
